export const LEGAL_FORM_KEYS = {
  NOTE: 'NOTE',
  CERTIFICATE: 'CERTIFICATE',
  WARRANT: 'WARRANT',
  DEPOSIT: 'DEPOSIT',
  EIS: 'EIS',
  OTC: 'OTC',
  COVERED_BOND: 'COVERED_BOND',
};

export const LEGAL_FORM = [
  { id: LEGAL_FORM_KEYS.NOTE, displayValue: 'Note' },
  { id: LEGAL_FORM_KEYS.CERTIFICATE, displayValue: 'Certificate' },
  { id: LEGAL_FORM_KEYS.WARRANT, displayValue: 'Warrant' },
  { id: LEGAL_FORM_KEYS.DEPOSIT, displayValue: 'Deposit' },
  { id: LEGAL_FORM_KEYS.EIS, displayValue: 'EIS' },
  { id: LEGAL_FORM_KEYS.OTC, displayValue: 'OTC' },
  { id: LEGAL_FORM_KEYS.COVERED_BOND, displayValue: 'Covered Bond' },
];

export const FORM_OF_SECURITIES = [
  { id: 'BEARER_PERMANENT', displayValue: 'Bearer Permanent' },
  { id: 'BEARER_TEMPORARY', displayValue: 'Bearer Temporary' },
  { id: 'REGISTERED', displayValue: 'Registered' },
];
